<template>
    <div>
        <div style="margin: 20px 15px; font-size: 18px; font-weight: bold;">
            <span>今日销售情况</span>
        </div>
        <van-cell-group>
            <van-cell title="充值笔数" :value="count" size="large"/>
            <van-cell title="充值金额" :value="amount" size="large"/>
            <van-cell title="利润" :value="profit" size="large"/>
        </van-cell-group>
        <div style="margin: 20px 15px; font-size: 18px; font-weight: bold;">
            <span>实用工具</span>
        </div>
        <van-cell-group>
            <van-cell title="交易查询" size="large" is-link to="alltrade"/>
            <van-cell title="加款查询" size="large" is-link to="alladditional"/>
            <van-cell title="客户余额查询" :value="totalBalance" size="large" is-link to="allaccount"/>
        </van-cell-group>
    </div>
</template>

<script>
import { Cell, List, Dialog } from "vant";
import kanbanApi from "@/api/kanban";

export default {
  name: "Kanban",

  data() {
      return {
          auth: false,
          count: 0,
          amount: 0,
          profit: 0,
          totalBalance: 0,
      }
  },

  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Dialog.name]: Dialog
  },

  mounted() {
    kanbanApi.daily().then(res => {
        this.count = res.data.daily.count;
        this.amount = res.data.daily.amount;
        this.profit = res.data.daily.profit;
        this.totalBalance = res.data.totalBalance
    })
  }
    
}
</script>